import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { RemoveButton } from 'screens/Admin/components';
import styled from 'styled-components';

const ContentImg = styled.img`
  flex: 1;
  min-height: 225px;
  max-height: 300px;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  object-fit: contain;
`;

const WebsiteView = ({ metaData, dimensions, remove, isAdmin }) => {
  const { title, description, url, image, icon } = metaData;
  const contentDimms = dimensions || 468; // '552px'
  const textWid = contentDimms - 48;

  return (
    <Col>
      {isAdmin && (
        <Text marg="24px 16px 5px" b2 med>
          Link
        </Text>
      )}

      <Col pos="relative">
        {isAdmin && <RemoveButton onClick={remove} />}

        <Clickable wid={`${contentDimms}px`} onClick={() => window.open(url, '_blank')}>
          <Col noFLex>
            <ContentImg src={image || icon} resizeMode="contain" />

            <Col noFlex pad="0 24px">
              <Text med marg="12px 0 0" wid={`${textWid}px`} col={!isAdmin && '#fff'}>
                {title}
              </Text>

              <Text wid={`${textWid}px`} marg="4px 0 0" col={!isAdmin && '#fff'} c1>
                {description}
              </Text>

              <Row noFlex marg="4px 0 0" start>
                <Text wid={`${contentDimms / 2}px`} c1 col={!isAdmin && '#fff'}>
                  {url}
                </Text>

                <Icon type="link" col={theme.GREY_60} marg="0 0 0 4px" dimensions={16} />
              </Row>
            </Col>
          </Col>
        </Clickable>
      </Col>
    </Col>
  );
};

export default WebsiteView;
